module.exports = __webpack_public_path__ + "static/media/message-question.4ef16a21.svg";